import { format } from 'owa-localize';

import {
    TODO_API_GET_COMPLETED_TASKS_IN_FOLDER_FORMAT,
    TODO_API_DEFAULT_FOLDER,
} from './constants';
import { makeTodoGetRequest } from './makeTodoGetRequest';
import { GetTasksResponse } from './GetTasksServiceResponse';
/**
 * Makes the Get tasks call to the server to get recently completed task items for the specified folder
 * or the default tasks folder if not specified.
 * @param {number} maxTaskToFetch maximum number of tasks to fetch
 * @param {string} folderId optional folder id of requested task folder
 * @returns promise of GetTasksServiceResponse
 */
export default function getRecentlyCompletedTasksService(
    maxTaskToFetch: number,
    folderId?: string
): Promise<GetTasksResponse> {
    const folderIdToUse = folderId ? folderId : TODO_API_DEFAULT_FOLDER;
    const url = format(
        TODO_API_GET_COMPLETED_TASKS_IN_FOLDER_FORMAT,
        folderIdToUse,
        maxTaskToFetch.toString() // to prevent the number from being localized by format
    );
    const actionName = 'GET_COMPLETED_TASKS';
    return makeTodoGetRequest(url, actionName);
}
